import { render, staticRenderFns } from "./StepNovo.vue?vue&type=template&id=2c9fed10"
import script from "./StepNovo.vue?vue&type=script&lang=js"
export * from "./StepNovo.vue?vue&type=script&lang=js"
import style0 from "./StepNovo.vue?vue&type=style&index=0&id=2c9fed10&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports